
const Index = () => import(/* webpackChunkName: "product-report" */ "./index");
const ProductList = () => import(/* webpackChunkName: "product-report" */ "./ProductList");
const ProductNotSold = () => import(/* webpackChunkName: "product-report" */ "./NotSold");
const ProductReorder = () => import(/* webpackChunkName: "product-report" */ "./Reorder");
const ProductHistory = () => import(/* webpackChunkName: "product-report" */ "./History");

export default [{
  path: 'product',
  name: 'product',
  component: Index,
  redirect: {
    name: 'product-list-report'
  },
  children: [
    {
      path: 'list',
      name: 'product-list-report',
      component: ProductList,
    }, 
    {
      path: 'history/:id',
      name: 'product-history',
      component: ProductHistory,
    }, 
    {
      path: 'notSold',
      name: 'product-notsold-report',
      component: ProductNotSold,
    },
    {
      path: 'reorder',
      name: 'product-reorder-report',
      component: ProductReorder,
    },
  ],

}, ]